import { collection, onSnapshot, query, orderBy, limit } from 'firebase/firestore';
import { auth, db } from '../config/firebase';

const EMAIL_LOG_COLLECTION = 'email_log';

const getWorkerUrl = () => {
  const base = process.env.REACT_APP_EMAIL_WORKER_URL || '';
  return base.replace(/\/$/, '');
};

export const isEmailWorkerConfigured = () => Boolean(getWorkerUrl());

export const emailService = {
  /**
   * Send branded LP email via the Cloudflare Worker (Email Sending API).
   * Recipients must exist in users with allowed !== false.
   */
  sendLpEmail: async ({ subject, body, recipientEmails, portalUrl }) => {
    const workerUrl = getWorkerUrl();
    if (!workerUrl) {
      throw new Error(
        'REACT_APP_EMAIL_WORKER_URL is not set. Deploy the send-lp-email Worker first — see EMAIL_SETUP.md.'
      );
    }

    const user = auth.currentUser;
    if (!user) throw new Error('You must be signed in to send email.');

    const idToken = await user.getIdToken();
    const res = await fetch(`${workerUrl}/send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({
        subject,
        body,
        recipientEmails,
        portalUrl: portalUrl || window.location.origin,
      }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(data.error || `Send failed (${res.status})`);
    }
    return data;
  },

  /** Subscribe to recent sent-email log entries (fund admin read-only). */
  subscribeToEmailLog: (callback, errorCallback, maxEntries = 25) => {
    const q = query(
      collection(db, EMAIL_LOG_COLLECTION),
      orderBy('sentAt', 'desc'),
      limit(maxEntries)
    );
    return onSnapshot(
      q,
      (snapshot) =>
        callback(
          snapshot.docs.map((d) => ({
            id: d.id,
            ...d.data(),
          }))
        ),
      errorCallback
    );
  },
};
